export default "__VITE_ASSET__DwDRvbvC__"